export default __webpack_public_path__ + "static/media/amount.da474621.png";